export const SKIP_LINK_TO_PRODUCTS = "left-nav.skip-to-products";
export const SKIP_LINK_TO = "left-nav.skip-to";
export const SKIP_LINK_TO_PRODUCTS_FILTERS = "left-nav.skip-to-product-filters";
export const SKIP_LINK_TO_QUICK_FILTERS = "left-nav.skip-to-quick-filters";
